import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * SectionTitle — tiny uppercase kicker + serif heading + right-aligned
 * action. Used at the top of every carousel, every admin card, the
 * personalized shelf, etc.
 */
export interface SectionTitleProps {
  kicker?: ReactNode;
  heading: ReactNode;
  action?: ReactNode;
  className?: string;
  headingClassName?: string;
}

export function SectionTitle({
  kicker,
  heading,
  action,
  className,
  headingClassName,
}: SectionTitleProps) {
  return (
    <div className={cn('flex items-end justify-between gap-4', className)}>
      <div className="min-w-0">
        {kicker ? <div className="or-kicker mb-1">{kicker}</div> : null}
        <h2
          className={cn('font-display text-[22px] font-bold text-or-slate-900', headingClassName)}
        >
          {heading}
        </h2>
      </div>
      {action ? (
        <div className="shrink-0 text-[13px] font-semibold text-or-orange-600">{action}</div>
      ) : null}
    </div>
  );
}
